import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ListingComponent } from './listing/listing.component';
import { StudentService } from './_services/student.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from 'src/app/_services/token-interceptor.service';
import { ParentService } from './_services/parent.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { RequestCardComponent } from './listing/request-card/request-card.component';
import { PrintModalComponent } from './print-modal/print-modal.component';
import { SharedModule } from '../shared/shared.module';
import { AddParentComponent } from './add-parent/add-parent.component';
import { AddStudentComponent } from './add-student/add-student.component';
// import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AnnouncementAlertComponent } from './announcement-alert/announcement-alert.component';
import { EditRequestCardComponent } from './listing/request-card/edit-request-card/edit-request-card.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { DeclineEarlyDismissalComponent } from './listing/request-card/decline-early-dismissal/decline-early-dismissal.component';
import { PermissionsModule } from '../shared/permissions/permissions.module';
import { OtpInterceptor } from '../_services/otp-interceptor.service';


@NgModule({
  declarations: [ListingComponent, RequestCardComponent, PrintModalComponent, AddStudentComponent, AddParentComponent, AnnouncementAlertComponent, EditRequestCardComponent , DeclineEarlyDismissalComponent],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    NgbTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PermissionsModule,
    InfiniteScrollModule,
    GoogleMapsModule
    // AgmCoreModule.forRoot({
    //   // apiKey: 'AIzaSyDscQPjxngryXG3CzHqg15f2dAz0aSyjTU',
    //   // apiKey: 'AIzaSyDqjIdjtHmnHvvjcRFloSGi6eqdl1tRGFw',
    //   apiKey: environment.googleKey,
    //   libraries: ["places"]
    // }),
  ],
  providers: [
    StudentService,
    ParentService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, 
      useClass: OtpInterceptor, 
      multi: true 
    }
  ],
  exports: [
    HttpClientModule,
    AddStudentComponent,
    AddParentComponent
  ]
})
export class UserManagementModule { }
